import { render } from "./RestrictedView.vue?vue&type=template&id=5f64c9fc&scoped=true"
import script from "./RestrictedView.vue?vue&type=script&lang=js"
export * from "./RestrictedView.vue?vue&type=script&lang=js"

import "./RestrictedView.vue?vue&type=style&index=0&id=5f64c9fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f64c9fc"]])

export default __exports__